// my-purchases.js - signed-in user's Stripe checkout history.
// Reads /api/stripe/my-purchases (local payment records, no Stripe roundtrip).
// Renders as a modal anchored under the user menu.

function token() { return localStorage.getItem('gdbs_token') || ''; }

async function api(method, path) {
  const headers = { 'Content-Type': 'application/json' };
  if (token()) headers['Authorization'] = 'Bearer ' + token();
  const res = await fetch(path, { method, headers });
  if (!res.ok) throw new Error(`${method} ${path}: ${res.status}`);
  return res.json();
}

function escapeHtml(s) {
  if (s === null || s === undefined) return '';
  return String(s).replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;' }[c]));
}

function formatAmount(cents) {
  if (typeof cents !== 'number') return '-';
  return '$' + (cents / 100).toFixed(2);
}

function statusBadge(s) {
  const sl = (s || '').toLowerCase();
  let color = 'var(--text-dim)';
  if (sl === 'completed') color = '#10b981';
  else if (sl === 'pending') color = '#3b82f6';
  else if (sl === 'failed' || sl === 'expired') color = '#dc2626';
  return `<span style="display:inline-block;padding:2px 8px;border-radius:9999px;font-size:10.5px;font-weight:600;background:color-mix(in oklch, ${color} 18%, transparent);color:${color};text-transform:uppercase;letter-spacing:0.04em;">${escapeHtml(sl)}</span>`;
}

let _modal = null;

function ensureModal() {
  if (_modal) return _modal;
  const overlay = document.createElement('div');
  overlay.id = 'my-purchases-modal';
  overlay.style.cssText = 'position:fixed;inset:0;background:color-mix(in oklch,var(--text) 55%,transparent);z-index:10500;display:none;align-items:center;justify-content:center;';
  overlay.innerHTML = `
    <div style="background:var(--bg-card,var(--bg-panel));border:1px solid var(--border);border-radius:var(--r-md,8px);
                box-shadow:0 20px 60px color-mix(in oklch,var(--text) 30%,transparent);
                min-width:680px;max-width:90vw;max-height:80vh;display:flex;flex-direction:column;overflow:hidden;">
      <div style="display:flex;justify-content:space-between;align-items:center;padding:14px 18px;border-bottom:1px solid var(--border);">
        <h3 style="margin:0;font-size:15px;color:var(--text);"><i class="fas fa-receipt" style="color:var(--accent);margin-right:8px;"></i>My Purchases</h3>
        <button type="button" id="mp-close" style="background:transparent;border:0;font-size:20px;color:var(--text-dim);cursor:pointer;line-height:1;">&times;</button>
      </div>
      <div id="mp-status" style="padding:8px 18px;font-size:11px;color:var(--text-dim);"></div>
      <div style="flex:1;overflow-y:auto;padding:0 18px 18px 18px;">
        <table class="plasma-table" id="mp-table" style="width:100%;">
          <thead><tr><th>Date</th><th>Modules</th><th>Amount</th><th>Status</th><th>Session</th></tr></thead>
          <tbody id="mp-body"><tr><td colspan="5" style="padding:20px;color:var(--text-dim);text-align:center;">Loading...</td></tr></tbody>
        </table>
      </div>
    </div>`;
  document.body.appendChild(overlay);
  overlay.addEventListener('click', e => { if (e.target === overlay) close(); });
  overlay.querySelector('#mp-close').addEventListener('click', close);
  _modal = overlay;
  return overlay;
}

function close() { if (_modal) _modal.style.display = 'none'; }

async function open() {
  const overlay = ensureModal();
  overlay.style.display = 'flex';
  const status = document.getElementById('mp-status');
  const body = document.getElementById('mp-body');
  status.textContent = 'Loading your purchases...';
  body.innerHTML = '<tr><td colspan="5" style="padding:20px;color:var(--text-dim);text-align:center;">Loading...</td></tr>';
  try {
    const res = await api('GET', '/api/stripe/my-purchases?limit=100');
    const rows = (res.data && res.data.rows) || [];
    if (rows.length === 0) {
      status.textContent = 'No purchases yet.';
      body.innerHTML = '<tr><td colspan="5" style="padding:20px;color:var(--text-dim);text-align:center;">You have no purchase history yet. When you check out, your transactions will appear here.</td></tr>';
      return;
    }
    status.textContent = `${rows.length} purchases on record.`;
    body.innerHTML = rows.map(r => {
      const date = (r.createdAt || r.CreatedAt || '').slice(0, 19).replace('T', ' ');
      const plans = (r.plans || r.Plans || []).join(', ');
      const amount = formatAmount(r.amountCents ?? r.AmountCents);
      const sid = r.sessionId || r.SessionId || '';
      return `<tr>
        <td><code>${escapeHtml(date)}</code></td>
        <td>${escapeHtml(plans)}</td>
        <td style="text-align:right;font-variant-numeric:tabular-nums;">${escapeHtml(amount)}</td>
        <td>${statusBadge(r.status || r.Status)}</td>
        <td><code title="${escapeHtml(sid)}" style="font-size:11px;">${escapeHtml(sid.slice(0, 18))}...</code></td>
      </tr>`;
    }).join('');
  } catch (e) {
    status.textContent = 'Failed to load: ' + e.message;
    body.innerHTML = `<tr><td colspan="5" style="padding:20px;color:var(--accent-red,oklch(60% 0.20 25));text-align:center;">${escapeHtml(e.message)}</td></tr>`;
  }
}

window.gdbsOpenMyPurchases = open;
